import { Link } from "react-router-dom";
import { formatPlayCount, getCategoryName, getHotVideos } from "@/data/videos";

export default function HotRanking() {
  const videos = getHotVideos(8);

  return (
    <section className="container-page py-10 md:py-14">
      <div className="mb-6">
        <h2 className="flex items-center gap-2 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
            <i className="ri-fire-line text-lg"></i>
          </span>
          热播榜单
        </h2>
        <p className="mt-1 text-sm text-foreground-500">
          依据播放量实时排序，看看大家都在追什么
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-x-8 md:gap-y-2">
        {videos.map((video, i) => (
          <Link
            key={video.id}
            to={`/detail/${video.id}`}
            className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-2.5 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span
              className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-extrabold ${
                i < 3
                  ? "bg-accent-500 text-background-50"
                  : "bg-secondary-100 text-secondary-700"
              }`}
            >
              {i + 1}
            </span>
            <div className="relative h-14 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 sm:w-28">
              <img
                src={video.cover}
                alt={video.title}
                title={`${video.title} 免费在线观看`}
                className="h-full w-full object-cover"
              />
              <span className="absolute bottom-1 right-1 rounded bg-foreground-950/80 px-1 text-[10px] font-label text-background-50">
                {video.duration}
              </span>
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="line-clamp-1 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                {video.title}
              </h3>
              <p className="mt-1 flex flex-wrap items-center gap-x-2 text-xs text-foreground-500">
                <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-700">
                  {getCategoryName(video.categoryId)}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {formatPlayCount(video.playCount)}
                </span>
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}